import request from '../utils/request';
// import qs from "qs";

export function getActorList(param) {
    return request({
        url: '/admin/getAuthorityList',
        method: 'GET',
        params: param
    })
}

export function setActor(id,param) {
    if (id) {
      return request({
        url: '/admin/updateAuthority',
        method: 'PUT',
        data: param
      })
    } else {
      return request({
        url: '/admin/createAuthority',
        method: 'POST',
        data: param
      })
    }
  }

  export function removeActor(data) {
    return request({
      url: '/admin/deleteAuthority',
      method: 'DELETE',
      data
    })
  }


  export function actorDetail(id) {
    return request({
      url: `/admin/getAuthority?id=${id}`,
      method: 'GET'
    })
  }

  export function setActorMenu(data) {
      return request({
        url: '/admin/updateAuthorityMenu',
        method: 'PUT',
        data
      })
  }